import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import styles from "../../styles/component.module.scss";
import DEFAULT_ROUTES from '../../constants/routes';
import { setActivePage } from '../../features/navigation/navigationSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import PageHeader from '../Header/PageHeader';
import FilesManager from './FilesManager';
const PAGE_TITLE = "File Manager";
const PAGE_DESCRIPTION = "All files uploaded by the user are managed and can be accessed within automation steps.";
const DEFAULT_PROJECT_NAME = "Project_Name";

const AssetsManagement = () => {
    const { selectedProject } = useSelector((state) => state.projects);
    const { activePage } = useSelector((state) => state.navigation);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    
    const handleBreadcrumbClick = (id) => {
        const breadcrumbMap = {
            home: {
                rURL: DEFAULT_ROUTES.BASE_URL,
                activePage: "Projects",
            },
            project: {
                rURL: `${DEFAULT_ROUTES.BASE_URL}${DEFAULT_ROUTES.PROJECT}/${selectedProject.id}/test-cases`,
                activePage: "Test Cases",
            },
        };

        const { rURL, activePage: nextActivePage } = breadcrumbMap[id] || {};

        if (nextActivePage) {
            dispatch(setActivePage(nextActivePage));
        }
        if (rURL) {
            navigate(rURL);
        }
    };

    const breadcrumbList = useMemo(() => {
        return [
            {
                label: "Project",
                onClick: () => handleBreadcrumbClick("home"),
              },
              {
                label: selectedProject?.name || DEFAULT_PROJECT_NAME,
                onClick: () => handleBreadcrumbClick("project"),
              },
              { label: activePage },
        ]
    }, [selectedProject, activePage]);
    

    return (
        <Box className={styles['page-container']}>
          <Box>
            <PageHeader 
                projectName={selectedProject?.name}
                title={PAGE_TITLE}
                description={PAGE_DESCRIPTION}
                activePage={activePage}
                breadcrumbItems={breadcrumbList}
                actions={[]}
            />
          </Box>
            <Box sx={{ width: '100%', padding: 0 }} className={styles['cover-container-col']}>
                <FilesManager />
            </Box>
        </Box>
    );
};

export default AssetsManagement;
